import { useState } from 'react';

import { WidgetViewMode, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { OptionValue } from 'components/common/CustomizedStatusSelect/CustomizedStatusSelect.types';

import { DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS, graphLineOptionsInflates } from 'components/widgets/SCurve/Scurve.utils';

const setInitialGraphOptions = (widgetViewMode: WidgetViewMode, localFilters) => {
    if (WidgetViewModeUtils.isPageView(widgetViewMode) || WidgetViewModeUtils.isReportAddWidget(widgetViewMode)) {
        return DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS;
    }
    // report view or report edit - should get from stored value
    return localFilters?.graphLineOptions
        ? graphLineOptionsInflates(localFilters.graphLineOptions)
        : DEFAULT_PAGE_VIEW_GRAPH_LINE_OPTIONS;
};

export const useGraphLineOptions = (widgetViewMode: WidgetViewMode, localFilters: any) => {
    const [graphLineOptions, setGraphLineOptions] = useState<OptionValue[]>(() =>
        setInitialGraphOptions(widgetViewMode, localFilters),
    );

    return [graphLineOptions, setGraphLineOptions] as const;
};
